export { CurrentPositionInfo } from './CurrentPositionInfo';
